import { IValidator } from '@samc/centricity-core';
import { IReportSchedule } from '@/Interfaces';

export class ReportScheduleValidator implements IValidator<IReportSchedule> {
  public isValid(value: IReportSchedule): Record<string, string> {
    const validations: Record<string, string> = {};

    if (value.exportName.length === 0)
      validations.exportName = 'Scheduled export name is required';

    if (value.reportGuid.length === 0)
      validations.reportGuid = 'Report is required';

    if (value.deliveryLocation.length === 0)
      validations.deliveryLocation = 'Destination location is required';

    if (value.fileName.length === 0)
      validations.fileName = 'Filename and path is required';

    return validations;
  }
}